export default "__VITE_ASSET__CgBg94HL__"